/*
 * NC Desktop-Lightbox – Navigation für Dawns <product-modal>
 * -----------------------------------------------------------
 * Erweitert (ohne Dawn-Core zu editieren) die native Produktbild-Lightbox:
 *  - Prev/Next-Pfeile scrollen das horizontale Carousel um eine Viewport-Breite
 *  - Pfeiltasten (ArrowLeft/ArrowRight) NUR wenn das Modal geöffnet ist
 *  - Zähler "aktuell / gesamt" folgt der Scroll-Position
 *  - öffnet beim Klick am angeklickten Bild (überschreibt Dawns Reset auf Bild 1)
 * Nur aktiv im <product-modal class="product-media-modal--nc">.
 * Nur relevant auf Desktop – auf Mobile ist der Trigger per CSS deaktiviert.
 */
(function () {
  'use strict';

  function initModal(modal) {
    if (modal.dataset.ncLightbox === 'ready') return;
    modal.dataset.ncLightbox = 'ready';

    var content = modal.querySelector('.product-media-modal__content');
    if (!content) return;

    var prevBtn = modal.querySelector('[data-nc-prev]');
    var nextBtn = modal.querySelector('[data-nc-next]');
    var curEl = modal.querySelector('.nc-lightbox__counter-current');
    var totEl = modal.querySelector('.nc-lightbox__counter-total');

    function items() {
      return Array.prototype.slice.call(
        content.querySelectorAll(':scope > [data-media-id]')
      );
    }

    function count() {
      return items().length;
    }

    function currentIndex() {
      var w = content.clientWidth || 1;
      var max = Math.max(0, count() - 1);
      return Math.min(max, Math.max(0, Math.round(content.scrollLeft / w)));
    }

    function updateUI() {
      var total = count();
      var idx = currentIndex();
      if (totEl) totEl.textContent = total;
      if (curEl) curEl.textContent = Math.min(total, idx + 1);
      if (prevBtn) prevBtn.toggleAttribute('disabled', idx <= 0);
      if (nextBtn) nextBtn.toggleAttribute('disabled', idx >= total - 1);
      modal.classList.toggle('nc-single', total <= 1);
    }

    function go(dir) {
      content.scrollBy({ left: dir * content.clientWidth, behavior: 'smooth' });
    }

    function scrollToMediaId(id, smooth) {
      if (!id) return;
      var list = items();
      var idx = -1;
      for (var i = 0; i < list.length; i++) {
        if (list[i].getAttribute('data-media-id') === String(id)) {
          idx = i;
          break;
        }
      }
      if (idx < 0) return;
      content.scrollTo({
        left: idx * content.clientWidth,
        behavior: smooth ? 'smooth' : 'auto'
      });
    }

    // WICHTIG: Dawns media-modal schließt bei jedem Maus-`pointerup`, dessen Ziel
    // NICHT in deferred-media/product-model liegt. Die Pfeil-Buttons liegen daneben
    // → ohne stopPropagation würde ein Klick auf den Pfeil das Modal SCHLIESSEN
    // statt zu blättern. Deshalb pointerdown/up (nicht nur click) auf den Buttons
    // stoppen. (click allein reicht nicht, weil das Schließen an pointerup hängt.)
    function wireNav(btn, dir) {
      if (!btn) return;
      ['pointerdown', 'pointerup', 'mousedown', 'mouseup'].forEach(function (ev) {
        btn.addEventListener(ev, function (e) { e.stopPropagation(); });
      });
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        go(dir);
      });
    }
    wireNav(prevBtn, -1);
    wireNav(nextBtn, 1);

    // Zähler-Klicks ebenfalls nicht zum Modal durchreichen (sonst Schließen)
    var counterEl = modal.querySelector('[data-nc-counter]');
    if (counterEl) {
      ['pointerdown', 'pointerup'].forEach(function (ev) {
        counterEl.addEventListener(ev, function (e) { e.stopPropagation(); });
      });
    }

    // Zähler folgt dem Scrollen (throttled per rAF)
    var raf = null;
    content.addEventListener(
      'scroll',
      function () {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(updateUI);
      },
      { passive: true }
    );

    // Pfeiltasten nur bei geöffnetem Modal
    document.addEventListener('keydown', function (e) {
      if (!modal.hasAttribute('open')) return;
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        go(-1);
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        go(1);
      }
    });

    // Beim Öffnen: an das angeklickte Bild springen + Zähler setzen
    var mo = new MutationObserver(function () {
      if (!modal.hasAttribute('open')) return;
      var id = modal.openedBy && modal.openedBy.getAttribute
        ? modal.openedBy.getAttribute('data-media-id')
        : null;
      // kurze Verzögerung, damit Dawns show()/showActiveMedia zuerst läuft
      setTimeout(function () {
        scrollToMediaId(id, false);
        updateUI();
      }, 60);
    });
    mo.observe(modal, { attributes: true, attributeFilter: ['open'] });

    updateUI();
  }

  function boot() {
    var modals = document.querySelectorAll('product-modal.product-media-modal--nc');
    Array.prototype.forEach.call(modals, initModal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
